import i18n from "@breward/i18n";

export const ADDITIONAL_FIELD_TYPES = {
  text: i18n.t("global:shared.EntryAdditionalFieldType.Text", "Text"),
  number: i18n.t("global:shared.EntryAdditionalFieldType.Number", "Numeric"),
  boolean: i18n.t(
    "global:shared.EntryAdditionalFieldType.Boolean",
    "Boolean (Yes/No)"
  ),
};

// Legacy helpers kept for compatibility with older UI flows.
export const PREDELIVERY_STATES = ["not_sent", "sent"];

export const JUDGING_STATES = [
  "assigned",
  "in_progress",
  "judged",
  "eliminated",
  "promoted",
];

export const ENTRY_PAYMENT_STATES = {
  pending: {
    label: "global:shared.EntryPaymentState.Pending",
    color: "warning",
    icon: "icon-[ph--clock]",
  },
  paid: {
    label: "global:shared.EntryPaymentState.Paid",
    color: "success",
    icon: "icon-[ph--money]",
  },
  refunded: {
    label: "global:shared.EntryPaymentState.Refunded",
    color: "error",
    icon: "icon-[ph--arrow-u-down-left]",
  },
  waived: {
    label: "global:shared.EntryPaymentState.Waived",
    color: "info",
    icon: "icon-[ph--hand-heart]",
  },
};

export const ENTRY_DELIVERY_STATES = {
  not_sent: {
    label: "global:shared.EntryDeliveryState.NotSent",
    color: "warning",
    icon: "icon-[ph--package]",
  },
  sent: {
    label: "global:shared.EntryDeliveryState.Sent",
    color: "info",
    icon: "icon-[ph--paper-plane-right]",
  },
  delivered: {
    label: "global:shared.EntryDeliveryState.Delivered",
    color: "success",
    icon: "icon-[ph--check-circle]",
  },
  returned: {
    label: "global:shared.EntryDeliveryState.Returned",
    color: "error",
    icon: "icon-[ph--arrow-counter-clockwise]",
  },
};

export const ENTRY_JUDGING_STATES = {
  not_assigned: {
    label: "global:shared.EntryJudgingState.NotAssigned",
    color: "disabled",
    icon: "icon-[ph--minus-circle]",
  },
  assigned: {
    label: "global:shared.EntryJudgingState.Assigned",
    color: "info",
    icon: "icon-[ph--device-tablet-speaker]",
  },
  in_progress: {
    label: "global:shared.EntryJudgingState.InProgress",
    color: "warning",
    icon: "icon-[ph--gavel]",
  },
  judged: {
    label: "global:shared.EntryJudgingState.Judged",
    color: "success",
    icon: "icon-[ph--scales]",
  },
  eliminated: {
    label: "global:shared.EntryJudgingState.Eliminated",
    color: "error",
    icon: "icon-[ph--x-circle]",
  },
  promoted: {
    label: "global:shared.EntryJudgingState.Promoted",
    color: "success",
    icon: "icon-[ph--trend-up]",
  },
};

export const ENTRY_LIFECYCLE_STATES = {
  registered: {
    label: "global:shared.EntryLifecycleState.Registered",
    color: "warning",
    icon: "icon-[ph--beer-bottle]",
  },
  active: {
    label: "global:shared.EntryLifecycleState.Active",
    color: "primary",
    icon: "icon-[ph--play-circle]",
  },
  cancelled: {
    label: "global:shared.EntryLifecycleState.Cancelled",
    color: "error",
    icon: "icon-[ph--prohibit]",
  },
  completed: {
    label: "global:shared.EntryLifecycleState.Completed",
    color: "success",
    icon: "icon-[ph--check-circle]",
  },
  archived: {
    label: "global:shared.EntryLifecycleState.Archived",
    color: "disabled",
    icon: "icon-[ph--archive]",
  },
};

// Legacy single-state flow (kept for backward compatibility).
export const ENTRY_STATES = {
  registered: {
    label: "global:shared.EntryState.Registered",
    color: "warning",
    icon: "icon-[ph--beer-bottle]",
  },
  paid: {
    label: "global:shared.EntryState.Paid",
    color: "success",
    icon: "icon-[ph--money]",
  },
  sent: {
    label: "global:shared.EntryState.Sent",
    color: "info",
    icon: "icon-[ph--car-profile]",
  },
  delivered: {
    label: "global:shared.EntryState.Delivered",
    color: "primary",
    icon: "icon-[ph--download-simple]",
  },
  assigned: {
    label: "global:shared.EntryState.Assigned",
    color: "info",
    icon: "icon-[ph--device-tablet-speaker]",
  },
  in_progress: {
    label: "global:shared.EntryState.InProgress",
    color: "warning",
    icon: "icon-[ph--gavel]",
  },
  judged: {
    label: "global:shared.EntryState.Judged",
    color: "success",
    icon: "icon-[ph--scales]",
  },
  eliminated: {
    label: "global:shared.EntryState.Eliminated",
    color: "error",
    icon: "icon-[ph--x-circle]",
  },
  promoted: {
    label: "global:shared.EntryState.Promoted",
    color: "success",
    icon: "icon-[ph--trend-up]",
  },
  completed: {
    label: "global:shared.EntryState.Completed",
    color: "disabled",
    icon: "icon-[ph--beer-stein]",
  },
  cancelled: {
    label: "global:shared.EntryState.Cancelled",
    color: "disabled",
    icon: "icon-[ph--prohibit]",
  },
};

export const PUBLIC_ENTRY_STATES = {
  pending: {
    label: "global:shared.EntryState.Pending",
    color: "warning",
    icon: "icon-[ph--clock]",
  },
  registered: {
    label: "global:shared.EntryState.Registered",
    color: "warning",
    icon: "icon-[ph--beer-bottle]",
  },
  paid: {
    label: "global:shared.EntryState.Paid",
    color: "success",
    icon: "icon-[ph--money]",
  },
  sent: {
    label: "global:shared.EntryState.Sent",
    color: "info",
    icon: "icon-[ph--car-profile]",
  },
  delivered: {
    label: "global:shared.EntryState.Delivered",
    color: "primary",
    icon: "icon-[ph--download-simple]",
  },
  assigned: {
    label: "global:shared.EntryState.Delivered",
    color: "primary",
    icon: "icon-[ph--device-tablet-speaker]",
  },
  in_progress: {
    label: "global:shared.EntryState.Delivered",
    color: "primary",
    icon: "icon-[ph--gavel]",
  },
  judged: {
    label: "global:shared.EntryState.Judged",
    color: "success",
    icon: "icon-[ph--scales]",
  },
  eliminated: {
    label: "global:shared.EntryState.Judged",
    color: "success",
    icon: "icon-[ph--scales]",
  },
  promoted: {
    label: "global:shared.EntryState.Judged",
    color: "success",
    icon: "icon-[ph--scales]",
  },
  completed: {
    label: "global:shared.EntryState.Completed",
    color: "disabled",
    icon: "icon-[ph--beer-stein]",
  },
  cancelled: {
    label: "global:shared.EntryState.Cancelled",
    color: "disabled",
    icon: "icon-[ph--prohibit]",
  },
};

export const PARCEL_STATES = {
  undamaged: {
    label: "global:shared.EntryParcelState.Undamaged",
    color: "success",
  },
  damaged: {
    label: "global:shared.EntryParcelState.Damaged",
    color: "warning",
  },
  broken: {
    label: "global:shared.EntryParcelState.Broken",
    color: "error",
  },
};

export const ENTRY_OPTIONAL_DATA = {
  abv: {
    label: "global:shared.EntryOptionalDataLabel.ABV",
    suffix: "%",
  },
  ibu: {
    label: "global:shared.EntryOptionalDataLabel.IBU",
    suffix: "IBU",
  },
  original_extract: {
    label: "global:shared.EntryOptionalDataLabel.OG",
    suffix: "°Blg",
  },
  final_extract: {
    label: "global:shared.EntryOptionalDataLabel.FG",
    suffix: "°Blg",
  },
};

export const ENTRY_TOKEN_TYPES = {
  initial: {
    label: "global:shared.EntryTokenTypeLabel.Initial",
  },
  stage: {
    label: "global:shared.EntryTokenTypeLabel.Stage",
  },
};

export const SCORESHEET_STATES = {
  created: {
    label: "global:shared.ScoresheetState.Created",
  },
  submitted: {
    label: "global:shared.ScoresheetState.Submitted",
  },
  approved: {
    label: "global:shared.ScoresheetState.Approved",
  },
  published: {
    label: "global:shared.ScoresheetState.Published",
  },
};
